module.exports = __webpack_public_path__ + "img/nav-right-expand-search-hyundai.343a89d0.png";